import { render, staticRenderFns } from "./OpportunityMenu.vue?vue&type=template&id=375c6b72&"
import script from "./OpportunityMenu.vue?vue&type=script&lang=js&"
export * from "./OpportunityMenu.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports